import * as yup from 'yup'
import { LOCATION_INVALID, TYPE_REQUIRED } from 'constants/errors'
import { zipCodeSchema } from 'helpers/schemaHelpers'
import { ObjectSchema } from 'yup'

export const basicCreditSchema = yup.object().shape({
  address1: yup.mixed().required(TYPE_REQUIRED),
  address2: yup.mixed(),
  city: yup.mixed().required(LOCATION_INVALID).test(
    'location-check', LOCATION_INVALID, (val: any) => Boolean(val && val.value)
  ).typeError(LOCATION_INVALID),
  zip5: zipCodeSchema,
})

export default yup.object().shape({
  ssn4: yup.string().required(TYPE_REQUIRED)
    .matches(/^[0-9]{4}$/, 'Must be 4 digits'),
}).concat(basicCreditSchema as ObjectSchema<any>)
